<template>
    <dialog-generic :visibility.sync = 'visibility' :indicator = 'indicator' :max-width = '$vuetify.breakpoint.smAndUp ? "50%": "95%"'>
        <template v-slot:title>Состояние загрузки</template>
        <template v-slot:content>
            <v-layout column align-center justify-center style = 'height: 350px;' v-show = 'indicator'>
                    <v-progress-circular indeterminate :color = '$store.getters.uiAccent' size = '32' width = '1'></v-progress-circular>
            </v-layout>
            <v-layout column v-show = '!indicator'>
                <v-tabs 
                    v-model = 'activeView' 
                    :slider-color = '$store.getters.uiAccent' 
                    :color = '$store.getters.uiAccent' 
                    grow input = 'boundTabEvent' 
                    :value = 'activeView'
                    show-arrows
                >
                    <template v-for = '(value, name) in details'>
                        <v-tab :key = 'name'>{{name}}</v-tab>
                        <v-tab-item :key = 'name' class = 'text-start' style = 'max-height: 350px; overflow: scroll;'>
                            <v-layout column class = 'font-weight-light' justify-start>
                                <v-flex d-flex row justify-space-between align-center mt-3 mb-1 pl-3 :style = '`color: ${!$vuetify.theme.dark?"black":"white"} !important;`'>
                                    <span class = 'subtitle-1'>Состояние представления: </span>
                                    <b v-if = 'value.actual_state && value.expected_state'>Настроено корректно</b>
                                    <b v-if = 'value.actual_state && !value.expected_state'>Настроено, данные отсутствуют</b>
                                    <b v-if = '!value.actual_state && value.expected_state'>Не настроено, данные присутствуют</b>
                                    <b v-if = '!value.actual_state && !value.expected_state'>Не настроено, данные отсутствуют</b>
                                </v-flex>
                                <template v-if = 'name == "costs"'>
                                    <v-list subheader three-line>
                                        <span class = 'subtitle-1'>Экспортируемые источники</span>
                                        <v-list-item 
                                            v-for = 's in value.state' 
                                            link
                                            :key = 's.source'
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span style = 'text-transform: uppercase;'>{{s.source}} </span>
                                                    <span class = 'caption'>({{s.max_export_table}})</span>
                                                </v-list-item-title>
                                                <v-list-item-subtitle class = 'caption my-0 py-0'>
                                                    Последнее обновление: {{s.updated}}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class = 'caption my-0 py-0'>
                                                    Последняя дата статистики: {{s.last_presented_date? s.last_presented_date: "нет"}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                            <v-list-item-action>
                                                <span>Таблиц всего: {{s.tables.length}}</span>
                                            </v-list-item-action>
                                        </v-list-item>
                                    </v-list>
                                </template>
                                <template v-if = 'name != "costs" && value.actual_state'>
                                    <v-flex d-flex row justify-space-between align-center mt-3 mb-1 pl-3 :style = '`color: ${!$vuetify.theme.dark?"black":"white"} !important;`'>
                                        <span class = 'subtitle-1'>Последняя дата статистики: </span>
                                        <b>{{value.state && value.state[0] && value.state[0].last_presented_date}}</b>
                                    </v-flex>
                                    <v-list subheader>
                                        <span class = 'subtitle-1'>Экспортируемые таблицы</span>
                                        <v-list-item 
                                            v-for = 's in (value.state && value.state[0] && value.state[0].tables)' 
                                            link
                                            :key = 's.name'
                                        >
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                    <span style = 'text-transform: uppercase;'>{{s.name}} </span>
                                                </v-list-item-title>
                                                <v-list-item-subtitle class = 'caption my-0 py-0'>
                                                    Дата создания: {{s.created}}
                                                </v-list-item-subtitle>
                                                <v-list-item-subtitle class = 'caption my-0 py-0'>
                                                    Дата обновления: {{s.updated}}
                                                </v-list-item-subtitle>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                </template>
                            </v-layout>
                        </v-tab-item>
                    </template>
                </v-tabs>
            </v-layout>
        </template>
    </dialog-generic>
</template>

<script>

    import DialogGeneric from '@/components/elements/dialogs/Generic.vue'
    import projectHandlers from '@/mixins/project'

    export default {
        name: 'ProjectState',
        mixins: [projectHandlers],
        props: ['initialState', 'data'],
        components: {'dialog-generic': DialogGeneric},
        data() {
            return {
                activeView: 0,
                visibility: this.initialState,
                project: this.data,
                indicator: false,
                details: {}
            }
        },
        watch: {
            initialState(value) {
                this.visibility = value
            },
            visibility(value) {
                this.$emit('update:initialState', value);
                if (value) {
                    this.getProjectState()
                }
            },
            data(value) {
                this.project = value
                this.getProjectState()
            }
        },
        methods: {
            copyTextToClipboard(text) {
                console.log('copy operation emitted');
                this.$copyText(text).then((r) => {
                    console.log('copy operation complete')
                }, (e) => {
                    console.log('copy operation failed');
                })
            },
            getProjectState() {
                this.indicator = true;
                this.getProjectPropertyPromise('state').then((r) => {
                    let response = r.body
                    this.indicator = false
                    if (response.result) {
                        this.details = response.data
                        this.activeView = Object.keys(this.details)[0]
                    } else {
                        console.log('error fetch project state', response.data)
                    }
                });
            }
        },
        mounted() {
        }
    }
</script>